Core.MfaLogin = function () {
    var CLS_HIDE = 'd-none';
    var param = new URLSearchParams(window.location.search);
    var id = param.get('id');
    var $el = $('.mfaLogin');

    function handleOption() {
        $('.mfaLogin-option').on('click', function () {
            Core.ShowPageLoading();            
            var $btn = $(this);     
            var authType = $btn.data('auth-type');
            var api = $btn.data('auth-api');
            var $box = $('.mfaLogin-box[data-auth-type="' + authType + '"]');

            switch (authType) {
                case 'app':
                    selectAuthApp(api, $box);
                    break;
                case 'sms':
                    selectAuthSms(api, $box);
                    break;
                case 'email':
                default:
                    selectAuthEmail(api, $box);
                    break;
            }
        });
    }

    function selectAuthApp(api, $box) {
        $.ajax({
            url: api,
            data: { id: id },
            type: 'POST',
            dataType: 'json',
            success: function (data) {
                $box.find('.mfaLogin-qrCode img').prop('src', data.qrCode);
                $box.find('.mfaLogin-code').html(data.code);
                $('.mfaLogin-box').addClass(CLS_HIDE);
                $box.removeClass(CLS_HIDE);
                $box.find('.mfaLogin-body').removeClass(CLS_HIDE);
            },
            error: function (xhr, status, error) {
                console.error({xhr, status, error});
            },
            complete: function () {
                Core.HidePageLoading();
            }
        });
    }

    function selectAuthSms(api, $box) {
        $.ajax({
            url: api,
            data: { id: id },
            type: 'POST',
            dataType: 'json',
            success: function (data) {
                if (!data.isSuccess) return;

                $('.mfaLogin-box').addClass(CLS_HIDE);
                if (data.requiredPhone) {
                    $box.find('.mfaLogin-body[data-step-sms="phone"]').removeClass(CLS_HIDE);
                } else {
                    $box.find('.mfaLogin-body[data-step-sms="otp"]').removeClass(CLS_HIDE);
                    $box.find('.mfaLogin-maskedPhone').html(data.mobileNumber);
                }

                $box.removeClass(CLS_HIDE);
            },
            error: function (xhr, status, error) {
                console.error({xhr, status, error});
            },
            complete: function () {
                Core.HidePageLoading();
            }
        });
    }

    function selectAuthEmail(api, $box) {
        $.ajax({
            url: api,
            data: { id: id },
            type: 'POST',
            dataType: 'json',
            success: function (data) {                
                if (!data.isSuccess) return;

                $('.mfaLogin-box').addClass(CLS_HIDE);
                $box.find('.mfaLogin-body[data-step-email="otp"]').removeClass(CLS_HIDE);
                $box.find('.mfaLogin-maskedEmail').html(data.email);
                $box.removeClass(CLS_HIDE);
            },
            error: function (xhr, status, error) {
                console.error({xhr, status, error});
            },
            complete: function () {
                Core.HidePageLoading();
            }
        });
    }

    function handleCancelButton() {
        $('.mfaLogin-btnCancel').on('click', function (e) {
            // if it's an anchor tag, redirect to href
            if ($(this).is("a")) return;

            $('.mfaLogin-box, .mfaLogin-body').addClass(CLS_HIDE);
            $('.mfaLogin-btnResendCode').prop('disabled', true);
            $('.mfaLogin-error').html('');
            $('.mfaLogin-form input').val('');

            var $firstBox = $el.find('.mfaLogin-box:first');
            $firstBox.removeClass(CLS_HIDE);
            $firstBox.find('.mfaLogin-body').removeClass(CLS_HIDE);
        });
    }

    // Verify button for app and sms
    function handleVerifyButton() {
        $el.find('form.mfaLogin-form__verify').on('submit', function (e) {
            e.preventDefault();
            var $form = $(this);
            var $box = $form.closest('.mfaLogin-box');
            if (!$form.valid()) return;

            Core.ShowPageLoading();
            var $error = $box.find('.mfaLogin-error');
            var authType = $box.data('auth-type');
            var api = '';

            switch (authType) {
                case 'app':
                    api = $el.data('verify-app-api');
                    break;                
                case 'sms':
                    api = $el.data('verify-sms-api');
                    break;                
                case 'email':
                default:
                    api = $el.data('verify-email-api');
                    break;
            }
            var isSetup = $el.data('setup') === true || $el.data('setup') === "true";

            $.ajax({
                url: api,
                data: { 
                    id: id, 
                    verificationCode: $form.find('input[name="verificationCode"]').val(),
                    trustedDevice: $form.find('input[name="trustedDevice"]').is(':checked'),
                },
                type: 'POST',
                dataType: 'json',
                success: function (data) {
                    if (data.isSuccess) {
                        $error.addClass(CLS_HIDE);

                        // is not setup, redirect to page
                        if (isSetup) {
                            $('.mfaLogin-box').addClass(CLS_HIDE);
                            $('.mfaLogin-box[data-step="3"], .mfaLogin-box[data-step="3"] .mfaLogin-body').removeClass(CLS_HIDE); 
                            $('.mfaLogin-redirectLink').prop('href', data.urlPage);  

                            Core.HidePageLoading();                        
                            // Redirect to page after 5 seconds
                            setTimeout(function () {
                                window.location.href = data.urlPage;
                            }, 5000);
                        } else {
                            window.location.href = data.urlPage;
                        }

                        return;
                    } else {
                        $error.html(data.message);
                        $error.removeClass(CLS_HIDE);
                        Core.HidePageLoading();
                    }
                },
                error: function (xhr, status, error) {
                    $error.html(status);
                    $error.removeClass(CLS_HIDE);
                    Core.HidePageLoading();
                }
            });
        });
    }

    function handleVerifyPhoneButton() {
        $el.find('form.mfaLogin-form__phone').on('submit', function (e) {
            e.preventDefault();
            var $form = $(this);
            var $box = $form.closest('.mfaLogin-box');
            if (!$form.valid()) return;

            Core.ShowPageLoading();       
            var $error = $box.find('.mfaLogin-error');
            var api = $('.mfaLogin').data('verify-phone-api');

            $.ajax({
                url: api,
                data: { 
                    id: id,
                    mobileNumber: $box.find('#mobileNumber').val(),
                },
                type: 'POST',
                dataType: 'json',
                success: function (data) {
                    if (data.isSuccess) {
                        $error.addClass(CLS_HIDE);
                        $box.find('.mfaLogin-maskedPhone').html(data.mobileNumber);
                        $box.find('.mfaLogin-body[data-step-sms="phone"]').addClass(CLS_HIDE);
                        $box.find('.mfaLogin-body[data-step-sms="otp"]').removeClass(CLS_HIDE);
                        enableResendCode();           
                    } else {
                        $error.html(data.message);
                        $error.removeClass(CLS_HIDE);
                    }
                },
                error: function (xhr, status, error) {
                    $error.html(status);
                    $error.removeClass(CLS_HIDE);
                },
                complete: function () {
                    Core.HidePageLoading();
                }
            });
        });
    
    }

    function enableResendCode() {
        var $btn = $('.mfaLogin-btnResendCode');
        var timeout = $btn.data('timeout');
        setTimeout(() => {
            $btn.prop('disabled', false);
            $btn.removeClass(CLS_HIDE);
        }, timeout || 10000); // default to 10 seconds
    }

    function handleResendCode() {
        var resendClickCounter = 0;

        $('.mfaLogin-btnResendCode').on('click', function () { 
            var $btn = $(this);
            var api = $('.mfaLogin').data('resend-code-api');
            var $box = $btn.closest('.mfaLogin-box');;
            var $error = $box.find('.mfaLogin-error');
            
            if (resendClickCounter > 4) {
                $btn.prop('disabled', true);
                $error.html('You have reached the maximum number of resend code. Please try again later.');
                $error.removeClass(CLS_HIDE);
                return;
            }

            Core.ShowPageLoading();
            $.ajax({
                url: api,
                data: { id: id },
                type: 'POST',
                dataType: 'json',
                success: function (data) {
                    $btn.prop('disabled', true);
                    $btn.addClass(CLS_HIDE);
                    if (data.isSuccess) {
                        enableResendCode();           
                        resendClickCounter++;
                    } else {
                        $error.html(data.message);
                        $error.removeClass(CLS_HIDE);
                    }
                },
                error: function (xhr, status, error) {
                    console.error({xhr, status, error});
                },
                complete: function () {
                    Core.HidePageLoading();
                }
            });
        });
    }

    function initForm() {
        $("input[type=checkbox]").uniform();

        $el.find('form').each(function () {
            $(this).validate({
                focusInvalid: false,
                invalidHandler: function (form, validator) {

                    if (!validator.numberOfInvalids())
                        return;

                    $(".mfaLogin-error").html('');
                }
            });
        });
    }

    function handleRedirectBtn() {
        $('.mfaLogin-redirectLink').on('click', function (e) {
            Core.ShowPageLoading();
        });
    }

    var m = {
        init: function () {
            initForm();
            handleOption();
            handleCancelButton();
            handleVerifyButton();
            handleVerifyPhoneButton();
            handleResendCode();
            handleRedirectBtn();

            if ($el.data('setup') === false || $el.data('setup') === "false") {
                enableResendCode();
            }
        },
    };

    return m;
};